import { useInfiniteQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { getInformations } from '../../../../api/information/queries/getInformations';
import { IInformation } from '../../../../interfaces/Information.interfaces';

interface IUseGetInformationsInfiniteQueryParams {
  searchParam: {
    category?: 'MAGAZINE' | 'NEWS';
    count: number;
  };
}

export const useGetInformationsInfiniteQuery = ({ searchParam }: IUseGetInformationsInfiniteQueryParams) => {
  return useInfiniteQuery<IInformation[], AxiosError>(
    ['informations_infinite', `category=${searchParam?.category}`, `count=${searchParam.count}`],
    ({ pageParam = 1 }) => {
      return getInformations({ searchParam: { ...searchParam, page: pageParam } });
    },
    {
      getNextPageParam: (lastPage, allPages) => {
        const nextPage = allPages.length + 1;
        return lastPage?.length === 0 || lastPage?.length < searchParam.count ? undefined : nextPage;
      },
      retry: 0,
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
    },
  );
};
